module.exports = __webpack_public_path__ + "img/ex-shower.531c9752.png";